import React, { useEffect, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Container, Row, Col } from 'react-bootstrap'
import OtherService from '../services/Other'
import Loader from '../component/Loader'
import RegistrationService from '../services/registration'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import { useNavigate } from 'react-router-dom'
import { Home } from 'react-feather';
import toast from 'react-hot-toast'
import { addBasicProfileDetails } from '../redux/slices/currentUserSlice'

const AddressList = () => {
    const dispatch = useDispatch()
    const ele = useRef(null)
    const [isAddress, setIsAddress] = useState([])
    const [isSelectedAddress, setIsSelectedAddress] = useState([])
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [isUser, setIsUser] = useState({ full_name: '', phone: '' })
    const [loading, setLoading] = useState(true);
    const [isSelectedAddressChoose, setIsSelectedAddressChoose] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState({id: "", title: ""});
    const [borderActive, setBorderActive] = useState(true)
    useEffect(() => {
        // setTimeout(() => {
        //     toast.success("Please select address");
        // }, 1000)
        const UserNameFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const UserNameFetchResponse = await RegistrationService.getBasicProfileInfo(token);
                if (UserNameFetchResponse.success == true) {
                    setIsUser(UserNameFetchResponse.response.basicProfileDetails)
                    dispatch(addBasicProfileDetails({ basicProfileDetails: UserNameFetchResponse.response.basicProfileDetails, canUpdate: UserNameFetchResponse.response.canUpdate }))
                    setLoading(false)
                }

            }
            catch (error) {
                console.error("User Name Fetch")

            }

        }
        UserNameFetchData()
    }, [])
    useEffect(() => {
        const AddressFetchData = async () => {
            try {
                const token = localStorage.getItem('access_token');
                const AddressFetchResponse = await OtherService.allAddresses(token);
                if (AddressFetchResponse.data.status == true) {

                    setIsAddress(AddressFetchResponse.data.addressDetails)
                    setLoading(false)
                }
            }
            catch (error) {
                console.error("Address Fetch")

            }

        }
        AddressFetchData()
    }, [])
    const navigate = useNavigate()
    const handleAddNewAddress = () => {
        navigate(`/add-new-address`)
    }

    const chooseAddress = (item) => {
        
        setSelectedAddress(item)
        if(item.is_old_address == 1) {
            navigate(`/edit-address/${item.id}`)
            return;
        }
        setIsEditAddress(true)
        setIsSelectedAddressChoose(true)
        setIsSelectedAddress(item)
    }
    const handleEditAddress = (addressId) => {
        navigate(`/edit-address/${addressId}`)
    }
    const handleProceed = (addressId) => {
        // navigate("/delivery", { state: { selectedAddress: isSelectedAddress } });   
        navigate(`/delivery/${addressId}`)
    }

    const changeBgColor = () => {
        
        if(window.scrollY < 2820) {
            setBorderActive(true)
        } else {
            setBorderActive(false)
        }
    }

    window.addEventListener('scroll', changeBgColor)
  
    return (
        <>
            {/* {loading && <Loader />} */}
            <BreadCrumbSecttion pageTitle="Address List" currentPageName="Address List" />
            <section className='padTop50'>
                <Container ref={ele}>
                    <Row>
                        {isAddress?.map((item, index) => {
                            const { line1, line2, line3, city, post_code ,district_name} = item
                            return (
                                <Col xs={12} md={6} lg ={4} key={index} className='mb-4'>

                                    <div className={`addressBlock ${isSelectedAddress && isSelectedAddress.id === item.id ? "selected" : ""}`} onClick={() => { chooseAddress(item) }} >
                                      <h4 className="section-title bborder-top">
                                            <span className="rgb-label grey-theme-background">
                                                <Home/>
                                            </span>
                                             My Address
                                        </h4>
                                        <div className='addressBlockWrap'>
                                            
                                            <div className='radioBtnArea'>
                                                <input type="radio"
                                                    name="chooseAddress"
                                                    value="Choose Address"
                                                    checked={selectedAddress.id == item.id}
                                                    onClick={() => { chooseAddress(item) }} />
                                            </div>
                                            <div className='addressBlockArea'>
                                                <div className='addressTxtWrap'><div className='firstBlock'>Name</div><div className='secondBlock'>{isUser?.full_name}</div></div>
                                                <div className='addressTxtWrap'><div className='firstBlock'>Address</div><div className='secondBlock'>{line1},{line2},{line3}</div></div>
                                                {district_name && <div className='addressTxtWrap'><div className='firstBlock'>District</div> <div className='secondBlock'>{district_name}</div></div>}
                                                <div className='addressTxtWrap'><div className='firstBlock'>PostCode</div> <div className='secondBlock'>{post_code}</div></div>
                                                <div className='addressTxtWrap'><div className='firstBlock'>Phone No</div><div className='secondBlock'>{isUser?.phone}</div></div>
                                            </div>
                                            {item.id == isSelectedAddress.id && isEditAddress && <span onClick={() => { handleEditAddress(item.id) }} className='editAddress '>
                                                <PrimaryGradientButton buttonText= "Edit Address" className="mt-3"/>
                                            </span>}
                                        </div>

                                    </div>

                                </Col>
                            )
                        })}

                    </Row>

                    <Row className={`buttonWrapBottom ${borderActive? 'hide':''}`}>

                        <Col xs={12} md ={6} lg={3}>
                            <PrimaryOutLineButton
                                outlinebuttonText="Add New Address"
                                onClick={handleAddNewAddress} />
                        </Col>
                        <Col xs={12} md ={6} lg={3}>
                            <PrimaryGradientButton buttonText="Proceed"
                                disabled={!isSelectedAddressChoose}
                                onClick={() => { handleProceed(isSelectedAddress.id) }} />
                        </Col>

                    </Row>

                </Container>
                <Row className={`buttonWrapBottom transition-2 sticky-bottom ${borderActive? 'border-active':'hide'}`}>

                        <Col xs={12} md ={6} lg={3}>
                            <PrimaryOutLineButton
                                outlinebuttonText="Add New Address"
                                onClick={handleAddNewAddress} />
                        </Col>
                        <Col xs={12} md ={6} lg={3}>
                            <PrimaryGradientButton buttonText="Proceed"
                                disabled={!isSelectedAddressChoose}
                                onClick={() => { handleProceed(isSelectedAddress.id) }} />
                        </Col>

                    </Row>
            </section>
        </>
    )
}

export default AddressList